import { useState } from "react";
import { Plus } from "lucide-react";
import { CreateProjectModal } from "../components/CreateProjectModal";
import { Link } from "react-router-dom";
import { useApiGet } from "../utils/api";

export const Dashboard = () => {
  const { data, unavailable, refetch } = useApiGet("/api/user/boards");
  const [showCreateModal, setShowCreateModal] = useState(false);

  if (unavailable) {
    return unavailable;
  }

  const { boards } = data;

  return (
    <div className="min-vh-100 bg-light">
      <main className="container main-content py-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h1 className="h3">My Idea Boards</h1>
          <button
            onClick={() => setShowCreateModal(true)}
            className="btn btn-primary d-flex align-items-center gap-2"
          >
            <Plus size={20} />
            <span>New Board</span>
          </button>
        </div>
        <div className="row g-4 fs-20">
          {boards.length === 0 && (
            <div className="text-muted">Create your first board to get started.</div>
          )}
          {boards.map((board: any) => (
            <div key={board.id}>
              <Link to={`/boards/${board.id}`} key={board.id}>
                <div>{board.name}</div>
              </Link>
              {board.is_collaboration && (
                <div className="fs-12 text-muted mt-1">Collaboration</div>
              )}
            </div>
          ))}
        </div>
      </main>
      {showCreateModal && (
        <CreateProjectModal onClose={() => setShowCreateModal(false)} refetch={refetch} />
      )}
    </div>
  );
};
